module.exports = __webpack_public_path__ + "static/media/IMG_0073.b8c3fbb5.jpg";